import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { ecommerceBenefits } from '../data/homepage';
export function EcommerceSection() {
  return <section id="ecommerce" aria-labelledby="ecommerce-title" className="bg-mist" data-id="element-43" data-mp="2ef9pdcbwq2ty">
      <div className="mx-auto grid max-w-[1280px] gap-10 px-5 py-12 md:px-8 md:py-16 lg:grid-cols-2 lg:gap-20 lg:py-20" data-id="element-44" data-mp="20jo2bap8ht46">
        <div data-id="element-45" data-mp="2s90zomxgpqqq">
          <h2 id="ecommerce-title" className="max-w-[520px] text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px]" data-id="element-46" data-mp="2s9atkllmoi1p">
            
            An online store built for how you sell.
          </h2>
          <p className="mt-5 max-w-[520px] text-[17px] leading-[1.6] text-ink/80" data-id="element-47" data-mp="2jfnvupxv14pv">
            Complex products, wholesale pricing, repeat orders, and custom checkout rules. We build around
            your business and connect the work behind each sale.
          </p>
          <ul className="mt-7 space-y-3" data-id="element-48" data-mp="3fyd9np0m62u3">
            {ecommerceBenefits.map(benefit => <li key={benefit} className="flex items-start gap-3 text-[16px] font-semibold leading-[1.5] text-ink" data-id="element-49" data-mp="2z0aar7j2yca5">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-greenDeep" strokeWidth={2.25} aria-hidden data-id="element-50" data-mp="2u28flo8dqmib" />
                {benefit}
              </li>)}
          </ul>
        </div>

        <div className="flex flex-col justify-center border-t border-mist-line pt-8 lg:border-l lg:border-t-0 lg:pl-16 lg:pt-0" data-id="element-51" data-mp="33zd3bshviq18">
          <p className="border-l-4 border-brand-orange pl-5 font-extrabold text-ink" data-id="element-52" data-mp="3hpgm29hjo1lx">
            <span className="block text-[80px] leading-none text-brand-greenDeep md:text-[104px]" data-id="element-53" data-mp="3doo9p7ddlglf">0%</span>
            <span className="mt-3 block max-w-[390px] text-[28px] leading-[1.15] md:text-[34px]" data-id="element-54" data-mp="3ropaynxjyq1f">
              WebsiteForge<br data-id="element-55" data-mp="3mqxjfv0tl5xr" />transaction fees.
            </span>
          </p>
          <p className="mt-4 max-w-[440px] pl-6 text-[16px] leading-[1.6] text-muted" data-id="element-56" data-mp="1xc97tw01zs0s">
            We don&rsquo;t take a percentage of your sales. Payment processor fees still apply.
          </p>
          <a href="#contact" className="group mt-8 inline-flex items-center gap-2 self-start whitespace-nowrap rounded-md bg-brand-orange px-6 py-3.5 text-[16px] font-bold text-ink transition-colors duration-150 ease-out hover:bg-brand-orangeHover" data-id="element-57" data-mp="3sf4fwxnmxbk0">
            
            Let&rsquo;s plan your store
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden data-id="element-58" data-mp="aaayuuz5kwmn" />
            
          </a>
        </div>
      </div>
    </section>;
}